const publicPaths = ['/account/login']

export default defineNuxtRouteMiddleware((to) => {
  if (!process.client) return
  if (publicPaths.some((path) => to.path.startsWith(path))) return

  const authStore = useAuthStore()
  authStore.rehydrateFromStorage()
  if (!authStore.isAuthenticated) {
    return navigateTo(`/account/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }
})
